
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Coral extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/data/explore?zoom=2&lat=-8.143523947839062&lng=31.322021484375004&basemap=dark&labels=light&layers=%255B%257B%2522dataset%2522%253A%2522fe9b286f-4b28-409a-85f5-2e81b2bd5056%2522%252C%2522opacity%2522%253A1%252C%2522layer%2522%253A%2522b3bdc1b3-807a-468a-9ff5-c62733321ef6%2522%257D%255D&page=1&sort=most-viewed&sortDirection=-1&topics=%255B%2522coral_reef%2522%255D'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Coral;